export const customerFields = /* GraphQL */ `
    __typename
    firstname
    lastname
    suffix
    email
    is_subscribed
    document_number
    date_of_birth
    customer_telephone
    is_subscribed
    addresses {
        uid
        id
        firstname
        lastname
        document_number
        street
        city
        comuna_id
        region {
            region_id
            region_code
            region
        }
        postcode
        country_code
        telephone
        default_shipping
        default_billing
    }
`
